import { getAggregatedInfo } from '@wix/ambassador-bookings-catalog-v1-business-info/http';
import { ApiContext } from '../../types';
import { legacyToSettingsResponse } from '@wix/bookings-calendar-catalog-viewer-mapper';
import {
  GetBookingsSettingsResponse,
  RequestedFields,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { ExperimentsConsts } from '../../../consts/experiments';
import { getBookingsSettings as getBookingsSettingsHttp } from '@wix/ambassador-bookings-v2-bookings-settings/http';

export const getBookingsSettings = async ({
  flowAPI,
}: ApiContext): Promise<GetBookingsSettingsResponse> => {
  const { httpClient, experiments } = flowAPI;
  if (experiments.enabled(ExperimentsConsts.BookingsAppSettingsMigration)) {
    return (
      await httpClient.request(
        getBookingsSettingsHttp({
          fields: [RequestedFields.SITE_PROPERTIES, RequestedFields.FEATURES],
        }),
      )
    ).data;
  }
  const aggregatedInfo = (await httpClient.request(getAggregatedInfo({}))).data;
  return legacyToSettingsResponse(aggregatedInfo);
};
